import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslations } from "@bsm/component";
import { useMemo } from "react";
import _ from "lodash";

export const StudentHealthAndAllergiesContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const value = useMemo(() => data?.healthAndAllergy, [data])
    const [
        HEALTH_AND_ALLERGIES,
        FOOD_ALLERGY_DETAILS,
        SEVERE_ALLERGY,
        DIETARY_REQUIREMENTS,
        SWEET_TREAT_REWARD,
        REWARD_ALTERNATIVE,
    ] = useTranslations(i18nKeys)
    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            <Box title={HEALTH_AND_ALLERGIES} className="flex flex-col gap-3 p-10">
                <Metadata label={FOOD_ALLERGY_DETAILS} value={!_.isEmpty(value?.foodAllergyDetails) && value?.foodAllergyDetails !== 'NONE' ? value?.foodAllergyDetails : 'None'} />
                <Metadata label={SEVERE_ALLERGY} value={value?.severeAllergy ? 'Yes' : 'No'} />
                <Metadata label={DIETARY_REQUIREMENTS} value={!_.isEmpty(value?.dietaryRequirements) && value?.dietaryRequirements !== 'NONE' ? value?.dietaryRequirements : 'None'} />
                <Metadata label={SWEET_TREAT_REWARD} value={value?.sweetTreatsReward ? 'Yes' : 'No'} />
                { 
                    !value?.sweetTreatsReward && <Metadata label={REWARD_ALTERNATIVE} value={value?.rewardAlternative} /> 
                }
            </Box>
        </div>
    );
}
const i18nKeys = [
    "std_health_and_allergies",
    "std_food_allergy_details",
    "std_severe_allergy",
    "std_dietary_requirements",
    "std_sweet_treat_reward",
    "std_reward_alternative",
]